import script from "./CoursewareList.vue?vue&type=script&lang=ts&setup=true"
export * from "./CoursewareList.vue?vue&type=script&lang=ts&setup=true"

import "./CoursewareList.vue?vue&type=style&index=0&id=22acd763&scoped=true&lang=css"
script.__scopeId = "data-v-22acd763"

export default script